<template>
  <div class="main">
    <ms-form-filter
      :filters="filters"
      default-search="title"/>
    <ms-grid
      :data="tasks"
      :columns="columns"
      :options="options"
      :pager="pager"
      @notFoundItem="newTasks">
      <el-checkbox
        slot="completed"
        slot-scope="{row}"
        v-model="row.completed"
        type="checkbox"
        @change="updateTask(row)"/>
      <span
        slot="title"
        slot-scope="{row}"
        :class="{completed:row.completed}">
        {{ row.title }}
      </span>
    </ms-grid>
  </div>
</template>

<script>
import MsGrid from '@/modules/grid/ms-grid'
import TaskGuards from '@/guards/tasks.guards'
import MsFormFilter from '@/components/_shared/ms-form-filter'
import moment from 'moment'
export default {
  name: 'TasksList',
  components: {
    MsGrid,
    MsFormFilter
  },
  props: {
    tasks: {
      type: Array,
      default: null
    },
    pager: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      complete: false,
      filters: [
        {
          type: 'date',
          property: 'createdAt',
          props: {
            label: 'Fecha de creación'
          },
          queryFunction: function (val) {
            let _query
            if (!Array.isArray(val)) {
              _query = {
                'filters[whereBetween][createdAt]': val ? [moment(val).format('YYYY-MM-DD'), moment(val).add(1, 'day').format('YYYY-MM-DD')] : null
              }
            } else {
              _query = {
                'filters[whereBetween][createdAt]': [moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')]
              }
            }
            return _query
          }
        },
        {
          type: 'date',
          property: 'dueDate',
          props: {
            label: 'Fecha programada'
          },
          queryFunction: function (val) {
            let _query
            if (!Array.isArray(val)) {
              _query = {
                'filters[whereBetween][dueDate]': val ? [moment(val).format('YYYY-MM-DD'), moment(val).add(1, 'day').format('YYYY-MM-DD')] : null
              }
            } else {
              _query = {
                'filters[whereBetween][dueDate]': [moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')]
              }
            }
            return _query
          }
        },
        {
          type: 'boolean',
          property: 'completed',
          props: {
            label: 'Estatus',
            options: [
              {
                label: 'Completada',
                value: true
              },
              {
                label: 'Por Completar',
                value: false
              }
            ]
          }
        }
      ],
      columns: [
        {
          property: 'completed',
          label: 'Completada',
          align: 'center'
        },
        {
          property: 'title',
          label: 'Nombre de la tarea',
          align: 'left'
        },
        {
          property: 'customer',
          label: 'Cliente',
          align: 'center'
        },
        {
          property: 'opportunity',
          label: 'Oportunidad',
          align: 'center'
        },
        {
          property: 'createdAt',
          label: 'Fecha de creación',
          align: 'center',
          type: 'date'
        },
        {
          property: 'dueDate',
          label: 'Fecha de programación',
          align: 'center',
          type: 'date'
        }
      ],
      options: {
        selectable: false,
        actions: [
          {
            label: 'Consultar',
            icon: 'icon-eye',
            onClick: (row) => {
              this.$store.dispatch('app/togglePrevTaskPanel')
              this.currentTaskValue(row)
            }
          },
          {
            label: 'Editar',
            icon: 'icon-edit',
            onClick: (row) => {
              this.$store.dispatch('app/toggleTasksPanel')
              this.editTask(row)
            }
          }
        ]
      }
    }
  },
  methods: {
    newTasks () {
      this.$store.dispatch('app/toggleTasksPanel')
    },
    updateTask (model) {
      this.$store.dispatch('tasks/save', model)
        .then(response => {
          this.$message.success('La tarea se ha actualizado con éxito')
        })
        .catch(e => {
          this.$message.error('La tarea no pudo se actualizada')
          model.completed = !model.completed
        })
    },
    currentTaskValue (task) {
      this.$emit('currentTaskValue', task)
    },
    editTask (task) {
      this.$emit('onEditTask', task)
    }
  },
  beforeRouteUpdate: TaskGuards.onEnter
}
</script>

<style scoped lang="scss">

  .completed{
    text-decoration: line-through ;
  }
  .main{
    background-color: #ffffff;
    min-height: 80vh;
  }

</style>



// WEBPACK FOOTER //
// src/modules/tasks/tasks-list.vue